import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';
import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';

export class AssetStorageSize extends PrimitiveValueObject<number> {
  static create(value: number): AssetStorageSize {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new AssetStorageSize(value);
  }
}
